(function ($) {

	class ThemeFront {

		constructor() {

			const self = this;

			this.setupContent();
			this.styleForms();

			$(document).on( 'gform_post_render', function(){
				self.styleForms();

				// gravity forms accessibility

				$('.g-recaptcha-response').each( function() {
					const $el = $(this);
					$el.attr('aria-hidden', 'true').attr('aria-label', 'do not use').attr('aria-readonly', 'true');
				});

			});

			this.handleHeaderCTA();
			this.handleBackdrop();
			this.handleHeaderLoginForm();
			this.handleHeaderSearchForm();
			this.handleHeaderMenu();
			this.handleHeaderMobileMenu();
			//this.setupHeaderScroll();
			this.setupMenuToggles();
			this.handlePopups();
			this.handleCarousels();
			this.handleToggles();
			this.handleDocumentsBlock();
			this.handleGlobalPopup();
			this.handleQuizCard();
			this.handleEventsPagination();
			this.handlePrintLinks();
			this.handleBlogPagination();
			this.handleContractorsSort();
			this.handlePagePasswordForm();
			this.handleSearchPagination();
			this.handleLangSelector();
			this.setupMySNOPUDLoginForm();
			this.setupVideos();
			this.handleJobsDirectory();

			$(window).trigger('resize');

		}

		/**
		 * Setup content
		 */
		setupContent() {

			const self = this;
			const currLang = $('html').attr('lang').replace( '-US', '');

			$('#head-lang-switcher-select').find('option[data-code=' + currLang + ']').attr('selected', 'selected');

			// responsive frames
			$('.block-text iframe').each( function() {

				const $iframe = $(this);

				if( $iframe.parents( '.ev_embed_group').length ) {
					return; 
				}

				if( ! $iframe.parent().hasClass( 'embed-container') ) {
					$iframe.wrap( '<div class="embed-container"></div>' );
				}

			});

			// responsive tables
			$('table').wrap('<div class="responsive-table"></div>');

			$( document ).on( 'click', '#sidebar .embed-container .overlay', function( e ) {			
				e.preventDefault();

				const $el = $(this),
				$iframe = $el.parents('.embed-container').find('iframe');

				console.log( $iframe.attr('src') );

				lity( $iframe.attr('src') );

			});

			$('input[value=gf_other_choice]').parents('.gchoice').addClass('gchoice-other');

			// $( 'body').children().not('iframe, script').each(function() {
			// 	$(this).html($(this).html().replace(/\u2028/g, ' '));
			// });


			if( $('body').hasClass('post-type-archive-team_member') && !self.isOldIE() ) {
				const url = new URL(window.location.href);

				let member = url.searchParams.get('member' );

				if( member && member != '' ) {

					console.log( $('#' + member).length );

					$( '#' + member ).addClass('is-active');
					$('body').addClass('is-popup-open');

				}

			}

		}

		/**
		 * Style forms
		 */
		styleForms() {

			$('.gform_wrapper .gfield_required').html( '*');

			$('input[type=radio], input[type=checkbox]').not( '.mysnopud-login-form input[type=radio], .mysnopud-login-form input[type=checkbox], .gchoice input[type=radio], .gchoice input[type=checkbox], .ginput_container_consent input[type=checkbox]').each( function() {
				const $input = $(this),
				inputType = $input.is(':checkbox') ? 'checkbox' : 'radio';
				$input.parents('label').addClass( `label-${inputType}`).wrap( `<div class="input-${inputType}"></div>`);
				$input.parent().contents().filter( function() {
					return this.nodeType === 3;
				}).wrap('<span/>');
			});

			$('input[type=number]').not( '.initialized').each( function() {
				const $input = $(this);

				if( $input.attr('step') != 'any' ) {
					$input.wrap( `<div class="input-number"></div>`);
					$input.parent().wrap( `<div/>`);
					$input.parent().append( '<button type="button" class="num-up"></button><button type="button" class="num-down"></button>');
					$input.addClass('initialized');
				}

			});

			$('.input-number .num-up').off( 'click').on( 'click', function( e ) {
				e.preventDefault();
				$(this).parent().find('input[type=number]')[0].stepUp();
			});

			$('.input-number .num-down').off( 'click').on( 'click', function( e ) {
				e.preventDefault();
				$(this).parent().find('input[type=number]')[0].stepDown();
			});

			$('select').each( function() {
				const $select = $(this);
				$select.selectric({
          nativeOnMobile: false,
          optionsItemBuilder: "<span>{text}</span>",
					onInit: function (element) {

						$(element)
							.closest(".selectric-wrapper")
							.find(".selectric-input")
							.attr("id", element[0].text)
							.insertBefore(
								"<label class='VisuallyHidden' aria-hidden='true'></label>"
							);
					},
        });
			});

			setTimeout( function() {
				$(".g-recaptcha-response").each(function () {
					$(this).attr("aria-hidden", "true");
					$(this).attr("aria-label", "do not use");
					$(this).attr("aria-readonly", "true");
				});
			}, 2000 );

			$('input[type=file]').not( '.initialized').each( function() {

				const $input = $(this);
				$input.addClass('initialized');

				$input.wrap( `<div class="input-file"></div>`);

				$input.wrap( `<label/>`);

				$input.parent().append('<span class="upload-title">' + SnopudConfig.strBrowse + '</span><span class="filename"></span>');

				$input.on( 'change', function() {

					const filename = this.files[0].name;
					$input.parents('.input-file').find('.filename').html( filename );

				});

			});

		}

		/**
		 * Header Call To Action
		 */
		handleHeaderCTA() {

			const self = this;

			if( self.getCookie( SnopudConfig.topBannerCookieName ) != 1 ) {
				$('#head-cta').show();
			}

			$('#head-cta-close').on( 'click', function( e ) {
				e.preventDefault();

				$('#head-cta').slideToggle( 'fast', function() {
					self.setCookie( SnopudConfig.topBannerCookieName, 1, 1 ); 
				});

			});

		}

		/**
		 * Backdrop for login form
		 */
		handleBackdrop() {

			const self = this;

			$('#backdrop').on( 'click', function() {
				$('body').removeClass('show-backdrop').removeClass('show-login-form').removeClass('is-popup-open');

				$('.popup').removeClass('is-active');

				if( $('#global-popup').length && $('#global-popup').is(':visible') ) {
					$('body').removeClass('is-global-popup-open');
					$('#global-popup').remove();
					self.setCookie( SnopudConfig.popupCookieName, 1, 1 );
				}

			});

		}

		/**
		 * Login form
		 */
		handleHeaderLoginForm() {

			$('#header-signin-btn, a[href=#open-signin-form], .header-signin-mobile-btn').on( 'click', function( e ) {
				e.preventDefault();

				if( SnopudConfig.signInType == 'redirect' ) {
					window.open( SnopudConfig.signInURL , '_blank').focus();
				} else {
					$('body').addClass('show-backdrop show-login-form');
				}

			});

			$('#mysnopud-login-form-close').on( 'click', function( e ) {
				e.preventDefault();
				$('body').removeClass('show-backdrop').removeClass('show-login-form');
			});

			$('.header-signin-mobile-btn').on( 'click', function( e ) {
				e.preventDefault();
				$('#popup-login-form').addClass('is-active');
				$('body').addClass('is-popup-open');
			});

			let prevWindowWidth = $( window ).width();

			$(window).on('resize', function() {

				// skip horizontal resize
				if( $(window).width() != prevWindowWidth ) {
					$('.mobile-popup, .popup').removeClass('is-active');
					$('body').removeClass('is-popup-open');

					if( $(window).width() >= 576 ) {

					} else {
	
						$('body').removeClass('show-login-form');
	
						if( ! $('body').hasClass('is-global-popup-open') ) {
							$('body').removeClass('show-backdrop').removeClass('is-popup-open');
						}
	
					}

				}

			});

		}

		/**
		 * Header search form
		 */
		handleHeaderSearchForm() {

			$('.head-search-open').on( 'click', function( e ) {
				e.preventDefault();

				$('.head-search-form').addClass('is-open');
				$('#header .head-item-right').addClass('is-hidden');

				setTimeout( function() {
					$('.head-search-form').find('input[type=text]').focus();
				}, 150 );

			});

			$('.mobile-menu-search').on( 'click', function( e ) {
				e.preventDefault();
				setTimeout( function() {
					$('#popup-search').find('input[type=text]').focus();
				}, 150 );

			});

			$('.head-search-close').on( 'click', function( e ) {
				e.preventDefault();

				$('.head-search-form').removeClass('is-open');
				$('#header .head-item-right').removeClass('is-hidden');

			});

		}

		/**
		 * Header menu
		 */
		handleHeaderMenu() {

			$('.header-desktop .head-menu .menu > .menu-item > a').on( 'mouseover', function( e ) {

				const $li = $(this).parent();

				$('.header-desktop .head-menu .menu > .menu-item').not( $li ).removeClass('is-open');
				$li.addClass( 'is-open');
				$('body').addClass('is-mega-menu-open');

			});
			
			$('.header-desktop .head-menu .menu > .menu-item').on( 'mouseleave', function() {

				$('.header-desktop .head-menu .menu > .menu-item').removeClass('is-open');
				$('body').removeClass('is-mega-menu-open');

			});

			$('select.drop-menu').not('#head-lang-switcher-select').each( function() {

				const $select = $(this);

				$select.on('selectric-change', function() {

					let val = $(this).val(),
					currentLoc = location.protocol + '//' + location.host,
					currentLang = $('html').attr('lang');

					if( currentLang != '' && currentLang != 'en-US' && currentLang != 'en' ) {

						val = val.replace( currentLoc, currentLoc + '/' + currentLang );

					}

					if( val.indexOf( '#open-signin-form' ) !== -1 ) {

						$('#header-signin-btn').click();

					} else {

						window.location = val;

					}

					$(this).val('').selectric('refresh');
				});

			});

			// close menus on click outside
			$(document).on( 'click', function( e ) {

				if( $( e.target).closest( '.header-desktop .menu').length === 0) {
					$('.header-desktop .head-menu .menu > .menu-item').removeClass( 'is-open');
					$('body').removeClass('is-mega-menu-open');
				}

			});

		}

		/**
		 * Mobile header menu
		 */
		handleHeaderMobileMenu() {

			$('.mobile-popup .popup-close').on( 'click', function( e ) {
				e.preventDefault();
				$(this).parents('.mobile-popup').removeClass('is-active');
				$('body').removeClass('is-popup-open');
			});

			$('.popup-close').on( 'click', function( e ) {
				e.preventDefault();
				$(this).parents('.popup').removeClass('is-active');
				$('body').removeClass('is-popup-open');
			});

			$('.mobile-menu-search').on( 'click', function( e ) {
				e.preventDefault();
				$('#popup-search').addClass('is-active');
				$('body').addClass('is-popup-open');
			});

			$('.mobile-menu-toggle').on( 'click', function( e ) {
				e.preventDefault();
				const $link = $(this);

				$('body').toggleClass('is-mobime-menu-active');

				$link.toggleClass('is-active');
				$('.header-mobile .head-menu').toggleClass('is-active');
			});

		}

		/**
		 * Header scroll
		 */
		setupHeaderScroll() {

			// Header
			const $header = $('#header'),
			$spacer = $('#spacer');

			// Calc head offset
			let headOffset = $header.offset().top;

			$(window).on( 'scroll', function () {

				let headerHeight = $header.outerHeight();
				let scroll = $(window).scrollTop();

				if( scroll > headOffset) {

					$header.addClass('is-scrollable');
					$spacer.css( 'padding-top', headerHeight + 'px');

				} else {

					$header.removeClass( 'is-scrollable');
					$spacer.css( 'padding-top', 0);

				}

			});

		}

		/**
		 * Mobile menu toggles
		 */
		setupMenuToggles() {

			$('#footer-mobile .menu-item-has-children, .header-mobile .menu-item-has-children').append('<span class="toggle"></span>');

			$('#footer-mobile .menu-item-has-children > .toggle, .header-mobile .menu-item-has-children .toggle').on( 'click', function( e ) {
				e.preventDefault();
				e.stopPropagation();
				const $el = $(this).parent();
				$el.toggleClass('is-open');
				
			});

		}

		/**
		 * Mobile popups
		 */
		handlePopups() {

			$('.popup-opener > a, .popup-open').on('click', function( e ) {
				e.preventDefault();

				const $link = $(this),
				popupID = $link.attr('href');

				$( popupID ).addClass('is-active');
				$('body').addClass('is-popup-open');

			});


		}

		/**
		 * Carousels
		 */
		handleCarousels() {

			$('.carousel').slick({
				dots: false,
				infinite: true,
				speed: 300,
				centerMode: true,
				variableWidth: true,
				initialSlide: 1,
				rtl: $('body').hasClass('rtl'),
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							initialSlide: 0
						}
					},
				]
			}).on('afterChange', function( slick, instance ) {

				const $slider = $( instance.$slider );

				$slider.find('.slide-visible').removeClass('slide-visible');

				const $currSlide = $slider.find('.slick-current');
				$currSlide.addClass('slide-visible');
				$currSlide.prev( '.slide').addClass('slide-visible');
				$currSlide.next( '.slide').addClass('slide-visible');
			});

			const $currSlide = $('.carousel').find('.slick-current');
			$currSlide.addClass('slide-visible');
			$currSlide.prev( '.slide').addClass('slide-visible');
			$currSlide.next( '.slide').addClass('slide-visible');

		}

		/**
		 * Toggles
		 */
		handleToggles() {
			
			$('.toggles').each( function() {
				const $toggles = $(this),
				$allTitles = $toggles.find('.toggle-title'),
				$allContent = $toggles.find('.toggle-content');

				$toggles.find('.toggle-title > a').on( 'click', function( e ) {
					e.preventDefault();

					const $link = $(this),
					$title = $link.parent(),
					$content = $title.next('.toggle-content');

					$allTitles.not( $title ).removeClass('is-open');
					$title.toggleClass('is-open');

					$allContent.not( $content ).slideUp('fast');
					$content.slideToggle('fast');

				});

			});

		}

		/**
		 * Documents block
		 */
		handleDocumentsBlock() {

			$('.block-documents, .block-documents-w-thumbnail').each( function() {

				const $block = $(this),
				rowsPerPage = $block.data('rows-per-page');

				const makeLayout = function() {

					const $rows = $block.find('.row-docs');

					if( $rows.length > 1 ) {

						$rows.removeClass('pre-last').each( function() {

							const $row = $(this);
	
							if( $row.is(':visible') && ! $row.next('.row-docs').is(':visible') ) {
								$row.addClass('pre-last');
							}
	
						});

					}

				};

				makeLayout();

				$block.find('.btn-load-more').on( 'click', function( e ) {
					e.preventDefault();

					const $nextRows = $block.find('.row-invisible').slice(0, rowsPerPage);

					$nextRows.removeClass('row-invisible').addClass('row-visible').show();

					makeLayout();

					if( ! $block.find('.row-invisible').length ) {
						$block.find('.row-pagination').remove();
					}

				})

			});

		}

		/**
		 * Global popup
		 */
		handleGlobalPopup() {

			const self = this,
			$popup = $('#global-popup');

			const changeTimezone = function(date, ianatz) {

				// suppose the date is 12:00 UTC
				var invdate = new Date(date.toLocaleString('en-US', {
					timeZone: ianatz
				}));
			
				// then invdate will be 07:00 in Toronto
				// and the diff is 5 hours
				var diff = date.getTime() - invdate.getTime();
			
				// so 12:00 in Toronto is 17:00 UTC
				return new Date(date.getTime() - diff); // needs to substract
			
			}

			if( $('body').hasClass('is-global-popup') ) {

				//const timeinLANow = new Date().toLocaleString("en-US", {timeZone: 'America/Los_Angeles'});
				const timeInLANow = changeTimezone( new Date(), 'America/Los_Angeles' );

				let startTimeStr = $.trim( $popup.data('start-time') ),
				endTimeStr = $.trim( $popup.data('end-time') ),

				startDateParams = startTimeStr.split( ',').map(Number),
				endDateParams = endTimeStr.split( ',').map(Number);

				// OMFG! https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/Date 
				// monthIndex
				/// Integer value representing the month, beginning with 0 for January to 11 for December.
				startDateParams[1] = startDateParams[1] - 1;
				endDateParams[1] = endDateParams[1] - 1;

				let startDateTime = new Date( ...startDateParams ),
				endDateTime = new Date( ...endDateParams );

				const datenow = new Date();

				console.warn( `Time in LA now: ${timeInLANow}` );
				console.error( `Local time now: ${datenow}` );
				// console.warn( startDateTime );
				// console.warn( endDateTime );

				let showPopup = self.getCookie( SnopudConfig.popupCookieName ) != 1;

				if( startTimeStr != '' && timeInLANow.getTime() < startDateTime.getTime() ) {
					console.log( `Popup is not ready yet`);
					showPopup = false;
				} 
				
				if( endTimeStr != '' && timeInLANow.getTime() > endDateTime.getTime() ) {
					console.log( `Popup display time is ended`);
					showPopup = false;
				}

				if( showPopup ) {

					setTimeout( function() {
						$popup.show();
						$('body').addClass('is-global-popup-open').addClass('show-backdrop');
					}, 500 );

				}

				$popup.find('.close').on( 'click', function( e ) {
					e.preventDefault();
					$('#backdrop').click();
				});

				$popup.find('.button-popup-primary-cta').on( 'click', function( e ) {
					self.setCookie( SnopudConfig.popupCookieName, 1, 1 );
				});

			}

		}

		/**
		 * Quiz card block
		 */
		handleQuizCard() {

			$('.block-quiz-card .button').on( 'click', function( e ) {
				e.preventDefault();

				const $btn = $(this),
				$answer = $( $btn.attr('href') ),
				$parent = $btn.parents('.block-quiz-card'),
				$choices = $parent.find('.choices'),
				$reset = $parent.find('.try-again'),
				$cta = $parent.find('.cta');

				$choices.fadeOut( 'fast', function() {
					$answer.fadeIn( 'fast');
					$reset.fadeIn( 'fast');
					$cta.fadeIn( 'fast');
				});

			});
			
			$('.block-quiz-card .try-again').on( 'click', function( e ) {
				e.preventDefault();

				const $btn = $(this),
				$parent = $btn.parents('.block-quiz-card');

				$parent.find('.answer:visible, .try-again, .cta').fadeOut( 'fast', function() {
					$parent.find('.choices').fadeIn( 'fast');
				});

			});

		}

		/**
		 * Events pagination
		 */
		handleEventsPagination() {

			if( $('.post-type-archive-event').length ) {

				$('#load-more-events').on( 'click', function( e ) {
					e.preventDefault();

					const $postsHolder = $('#events-list'),
					$link = $(this),
					paged = $link.data('nextpage');

					$.ajax({
						url: SnopudConfig.ajaxurl,
						type: 'POST',
						dataType: 'json',
						data: {
							'action' : 'theme_load_events',
							'nonce' : SnopudConfig.ajaxNonce,
							'paged' : paged
						},
						beforeSend: function() {
		
							$postsHolder.addClass('is-loading');
							$link.addClass('is-loading');
		
						},
						success: function( answer ) {
		
							$postsHolder.removeClass('is-loading');
							$link.removeClass('is-loading');
		
							$postsHolder.append( answer.html );
		
							$link.data('nextpage', answer.nextpage );
		
							if( answer.hide_link ) {
								$link.remove();
							} 
		
						}
					});

				});

			}

		}

		/** 
		 * Handle print links
		 */
		handlePrintLinks() {

			$('.snopud-print-img-btn').on( 'click', function( e ) {
				e.preventDefault();

				const $link = $(this),
				imgURL = $link.attr('data-url');

				const printWindow = window.open( '','', '');
				printWindow.document.write( '<img src="' + imgURL + '" alt="">');
				printWindow.document.close(); 
				printWindow.focus();
				printWindow.print(); 

			});

		}

		/**
		 * Blog pagination
		 */
		handleBlogPagination() {

			const self = this;

			$('#ajax-load-more-blog').on( 'click', function( e ) {
				e.preventDefault();
				self.loadBlogPosts( false );
			});

			$('.blog-filters a').on( 'click', function( e ) {
				e.preventDefault();
				const $link = $(this),
				categoryName = $link.attr('href'),
				categoryId = $link.attr('data-cat-id');

				if (!self.isOldIE()) {
					const url = new URL(window.location.href);
					let catName = categoryName.replace( '#', '');

					if( catName != '') {
						url.searchParams.set('category', catName);
					} else {
						url.searchParams.delete('category');
					}

					window.history.replaceState(null, null, url);
				}

				$('.blog-filters a').removeClass('is-active');
				$('.blog-filters a[href="' + categoryName + '"]').addClass('is-active');
				$('#ajax-load-more-blog').attr('data-filter-cat', categoryId );
				self.loadBlogPosts( true );
			});

			const checkBlogPagination = function() {
				const url = new URL(window.location.href),
				category = $.trim(url.searchParams.get('category'));

				if( $('.container-blog-posts').length ) {
					if( category != '') {
						$('.blog-filters a[href=#' + category + ']' ).click();
					}
				}

			};

			checkBlogPagination();

		}

		/**
		 * Detect old IE
		 */
		 isOldIE() {
			return !!window.MSInputMethodContext && !!document.documentMode;
		}

		/**
		 * Load posts
		 */
		 loadBlogPosts( again = false ) {

			const $link = $( '#ajax-load-more-blog'),
			$postsHolder = $( $link.data('posts-holder') );

			if( again ) {
				$link.addClass('is-again');
			}

			const isHeroPost = $('#blog-featured-post').length ? 1 : 0;

			let offset = $postsHolder.find('.post').not( '.col-post-sticky > .post').length;

			if( ! $link.hasClass( 'is-again' ) ) {
				offset = offset + isHeroPost;
			}

			$.ajax({
				url: SnopudConfig.ajaxurl,
				type: 'POST',
				dataType: 'json',
				data: {
					'action' : 'snopud_load_blog_posts',
					'load_again' : again,
					'query' : $link.attr('data-current-query'),
					'filter_cat' : $link.attr('data-filter-cat'),
					'offset' : offset
				},
				beforeSend: function() {

					$postsHolder.addClass('is-loading');

				},
				success: function( answer ) {

					$postsHolder.removeClass('is-loading');

					if( again ) {
						$postsHolder.html( answer.html );

						if( $(window).width() <= 1199 ) {
							$( 'html, body').stop().animate({ scrollTop: $('#blog-posts').offset().top }, 800 );
						}

					} else {
						$postsHolder.find('.col-post-sticky').remove();
						$postsHolder.append( answer.html );
					}

					$link.attr('data-current-query', JSON.stringify( answer.query ) );

					if( answer.hide_link ) {
						$link.hide();
					} else {
						$link.show();
					}

				}
			});

		}

		/**
		 * Sort contractors
		 */
		handleContractorsSort() {

			$('.tax-contractor_category .sorter a').on( 'click', function( e ) {
				e.preventDefault();

				const $link = $(this),
				$sorter = $link.parents('.sorter'),
				termId = $sorter.data('term'),
				sort = $link.attr('href'),
				$postsHolder = $('#posts');

				$('.tax-contractor_category .sorter a').not( $link ).removeClass('is-active');

				$('.tax-contractor_category .sorter a[href="' + sort + '"]').toggleClass('is-active');

				const currentFilter = $link.attr('href').replace('#', '');
				const sortType = $link.hasClass('is-active') ? 'DESC' : 'ASC'; 

				$.ajax({
					url: SnopudConfig.ajaxurl,
					type: 'POST',
					dataType: 'json',
					data: {
						'action' : 'snopud_sort_contractors',
						'nonce' : SnopudConfig.ajaxNonce,
						'filter' : currentFilter,
						'sort' : sortType,
						'termId' : termId
					},
					beforeSend: function() {
						$postsHolder.addClass('is-loading');
					},
					success: function( answer ) {
	
						$postsHolder.removeClass('is-loading');
						$postsHolder.html( answer.html );
	
					}
				});

			});

		}

		/**
		 * Check page password form
		 */
		handlePagePasswordForm() {

			$('#post-password-protection-form input[type=password]').on( 'focus', function() {
				$(this).removeClass('is-error');
			});

			$('#post-password-protection-form').on( 'submit', function( e ) {
				e.preventDefault();

				const $form = $(this),
				$passInput = $form.find('input[type=password]');

				$.ajax({
					url: SnopudConfig.ajaxurl,
					type: 'POST',
					dataType: 'json',
					data: {
						'action' : 'snopud_check_page_password',
						'p' : $passInput.val()
					},
					beforeSend: function() {

						$passInput.removeClass('is-error');
						$form.addClass('is-loading');

					},
					success: function( answer ) {
	
						$form.removeClass('is-loading');

						if( answer.result == false ) {

							$passInput.addClass('is-error');

						} else {

							location.reload();

						}
	
					}
				});


			});

		}

		/**
		 * Search pagination
		 */
		handleSearchPagination() {

			$('.search-form-main .search-clear').on( 'click', function( e ) {
				e.preventDefault();

				const $link = $(this),
				$form = $link.parents('form'),
				$search = $form.find('input[type=text]');

				$search.val('').focus();
				$link.addClass('is-hidden');

			});

			$('.search-form-main input[type=text]').on( 'keyup', function( e ) {
				e.preventDefault();

				const $search = $(this),
				$form = $search.parents('form'),
				$link = $form.find('.search-clear');

				$link.removeClass('is-hidden');

			});

			$('#ajax-load-more-search').on( 'click', function( e ) {
				e.preventDefault();

				const $link = $( this ),
				$postsHolder = $( $link.data('posts-holder') );
	
				const isHeroPost = $('#blog-featured-post').length ? 1 : 0;
	
				let offset = $postsHolder.find('article').length;
	
				$.ajax({
					url: SnopudConfig.ajaxurl,
					type: 'POST',
					dataType: 'json',
					data: {
						'action' : 'snopud_load_search_results',
						'query' : $link.attr('data-current-query'),
						'offset' : offset
					},
					beforeSend: function() {
	
						$postsHolder.addClass('is-loading');
	
					},
					success: function( answer ) {
	
						$postsHolder.removeClass('is-loading');
						$postsHolder.append( answer.html );
	
						$link.attr('data-current-query', JSON.stringify( answer.query ) );
	
						if( answer.hide_link ) {
							$link.hide();
						} else {
							$link.show();
						}
	
					}
				});

			});

		}

		/**
		 * MySNOPUD Login form
		 */
		setupMySNOPUDLoginForm() {

			/*
			$.ajax({
				//url: 'https://testmy.snopud.com/Home/GetLogIn',
				url: SnopudConfig.ajaxurl,
				data: {
					'action' : 'snopud_get_login_form'
				},
				success: function( result ) {
					$( '.mysnopud-login-form').html( result);
					$( '.mysnopud-login-form').find('.toggleForgotPassword').attr('target', '_blank');
					onLoginSubmit();
				}
			});
			*/

			$( '.mysnopud-login-form').find('.toggleForgotPassword').attr('target', '_blank');
			onLoginSubmit();

		}

		/**
		 * Fix no track Vimeo videos
		 */
		setupVideos() {
			// Remove do not track from vimeo videos
			$(document).ready(function($){
				$('iframe[src*="player.vimeo.com"]').each(function(){
					let src = $(this).attr('src');
					$(this).attr('src',src.replace('dnt=1&', 'dnt=0&'));
				});
			});
		}

		/**
		 * Jobs Directory
		 */
		handleJobsDirectory() {

			if ( $('.post-type-jobs-directory').length >= 1 ) {
				const $filter = $('#jobs-nav'),
				sticky = $filter.offset().top,
				filterHeight = $filter.outerHeight(),
				$jobsNavWrap = $('#jobs-nav-wrap');

				function stickyFilterLetter() {
					if ($filter) {
						if ($(document).scrollTop() > sticky + filterHeight) {
							$filter.addClass("sticky");
							$jobsNavWrap.css('padding-top', filterHeight);
						} else {
							$filter.removeClass("sticky");
							$jobsNavWrap.css('padding-top', 0);
						}

					}
				}

				function activeLetterFilter() {
					const scrollTop = $(document).scrollTop(),
						$firstItem = $('.jobs__letter:first'),
						firstItemOffset = $firstItem.offset().top;

					$('.jobs__letter').each(function (e) {
						const $letter = $(this),
							activeLetterElPos = $letter.offset().top,
							currentLetter = $letter.attr('id'),
							$letters = $('.jobs__hero--jump--items a'),
							$lett = $('.jobs__hero--jump--items a[data-letter="' + currentLetter + '"]');

						console.log( currentLetter );

						if (scrollTop >= activeLetterElPos - $('#jobs-nav').outerHeight()) {
							$letters.removeClass("is-active");
							$lett.addClass("is-active");
						} else if (scrollTop < firstItemOffset) {
							$letters.removeClass("is-active");
						}
					});
				}

				$('.jobs__hero--jump--items a').on( 'click', function( e ) {
					e.preventDefault();

					const $link = $(this),
					$to = $( $link.attr('href') );

					if( $to.length ) {
						window.scrollTo({ top: $to.offset().top - 80, behavior: 'smooth'});
					}

				});

				$(document).on('scroll', () => {
					stickyFilterLetter();
					activeLetterFilter();
				});

			}

		}

		/**
		 * Language selector
		 */
		handleLangSelector() {

			$('.popup-lang-selector a').on( 'click', function( e ) {
				e.preventDefault();

				const $link = $(this),
				langCode = $link.data('code');

				$link.parents('.mobile-popup').find( '.popup-close').click();

				doGTranslate( 'en|' + langCode);

			});

			$('#head-lang-switcher-select').on( 'change', function() {

				const $select = $(this),
				langCode = $select.find('option:selected').data('code');

				doGTranslate( 'en|' + langCode);

			});

		}

		/**
		 * Utilities
		 */
		setCookie( key, value, expiry = 7) {
			let expires = new Date();
			expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
			document.cookie = key + '=' + value + ';path=/;expires=' + expires.toUTCString();
		}

    getCookie( key) {
			var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
			return keyValue ? keyValue[2] : null;
		}

	}

	window.ThemeFront = new ThemeFront();
	
})(window.jQuery);
